import { render, staticRenderFns } from "./Index-SettingsMobile.vue?vue&type=template&id=180c73da&scoped=true"
import script from "./Index-SettingsMobile.vue?vue&type=script&lang=js"
export * from "./Index-SettingsMobile.vue?vue&type=script&lang=js"
import style0 from "./Index-SettingsMobile.vue?vue&type=style&index=0&id=180c73da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c73da",
  null
  
)

export default component.exports